import React, { memo, useEffect } from 'react';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { CategoryLandingPageSectionBlokProps } from './CategoryLandingPage';
import CategoryLandingPageSectionHeader from './CategoryLandingPageSectionHeader';
import ArticleCards from '../ArticleCards/ArticleCards';
import CTABarSmall, { CTABarSmallBlokProps } from '../CTABarSmall/CTABarSmall';
import { HeadingTypes } from '../Heading/Heading';
import { useInView } from 'react-intersection-observer';
import { formatStringForUrl } from '../../utils/formatStringForUrl/formatStringForUrl.util';
import useWindowDimensions from '../../hooks/useWindowDimensions';

interface CategoryLandingPageSectionProps {
  categoryLandingPageSections: CategoryLandingPageSectionBlokProps[];
  categoryLandingPageSection?: CategoryLandingPageSectionBlokProps;
  setActiveCategoryLandingPageSection: (state: string) => void;
}

const CategoryLandingPageSection: React.FC<CategoryLandingPageSectionProps> = ({
  categoryLandingPageSections,
  categoryLandingPageSection = null,
  setActiveCategoryLandingPageSection,
}) => {
  const { width, height } = useWindowDimensions();
  const adaptiveThreshold =
    width < 768
      ? 0.2
      : height < 700
      ? 0.3
      : height < 900
      ? 0.4
      : height < 1100
      ? 0.5
      : height < 1300
      ? 0.65
      : 0.75;

  const { ref, inView } = useInView({
    threshold: adaptiveThreshold,
    delay: 300,
  });

  useEffect(() => {
    if (inView) {
      setActiveCategoryLandingPageSection(
        formatStringForUrl(categoryLandingPageSection?.heading)
      );
    }
  }, [inView]);

  return (
    <article
      id={formatStringForUrl(categoryLandingPageSection?.heading) || ''}
      className="scroll-mt-28"
      ref={ref}
    >
      {categoryLandingPageSection && (
        <div className="space-y-16">
          <CategoryLandingPageSectionHeader
            categoryLandingPageSections={categoryLandingPageSections}
            selectedCategoryLandingPageSection={categoryLandingPageSection}
          />
          {categoryLandingPageSection.top_row_articles && (
            <ArticleCards
              articles_to_show={categoryLandingPageSection.top_row_articles}
              articleCardHeadingType={HeadingTypes.h3}
              articleCardHeadingStyleType={HeadingTypes.h4}
            />
          )}
          {categoryLandingPageSection.cta_bar?.map(
            (cta_bar: CTABarSmallBlokProps) => (
              <CTABarSmall key={cta_bar._uid} blok={cta_bar} />
            )
          )}
          {categoryLandingPageSection.bottom_row_articles && (
            <ArticleCards
              articles_to_show={categoryLandingPageSection.bottom_row_articles}
              articleCardHeadingType={HeadingTypes.h3}
              articleCardHeadingStyleType={HeadingTypes.h4}
            />
          )}
        </div>
      )}
    </article>
  );
};

export default memo(withBlokWrapper(CategoryLandingPageSection, Theme.LIGHT));
